module.exports = __webpack_public_path__ + "img/info.fc3d6818.svg";